<template>
  <div>
    <epi-modal :opening-event-name="openingEventName" title="고객 경로 추가">
      <template v-slot:body>
        <div>
          <label class="form-label">경로</label>
          <input
            type="text"
            class="form-control"
            placeholder="고객과 만난 경로(예: EAP)"
          />
        </div>

        <table class="table table-sm table-border-0">
          <thead>
            <tr>
              <th class="text-center">경로</th>
              <th style="width: 80px">변경</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="a in [
                '전화 예약',
                '홈페이지 예약',
                '트로스트',
                '탈잉',
                '네이버 예약',
                'EAP',
                '우울',
                '불안',
              ]"
              :key="a"
            >
              <td>{{ a }}</td>
              <td class="text-center">
                <div class="hstack gap-3">
                  <a class="text-black-50">
                    <i class="bi bi-pencil-square"></i>
                  </a>
                  <a class="text-danger">
                    <i class="bi bi-trash"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </template>
      <template v-slot:footer>
        <div class="d-flex w-100 justify-content-end align-items-center">
          <div class="hstack gap-2">
            <button class="btn btn-light" data-bs-dismiss="modal">취소</button>
            <button class="btn btn-light">추가</button>
          </div>
        </div>
      </template>
    </epi-modal>
  </div>
</template>

<script>
import { EventName } from "@/const";

export default {
  name: "CustomerReferrerAddModal",
  data() {
    return {
      openingEventName: EventName.CustomerReferrerAddModalOpening,
    };
  },
  mounted() {},
};
</script>
